import React from 'react';

export const DefaultEmptyState = () => (
  <div className="text-center py-12">
    <div className="mx-auto h-24 w-24 text-gray-400 dark:text-gray-600 mb-4">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414A1 1 0 0010 21H4"/>
      </svg>
    </div>
    <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">No data found</h3>
    <p className="text-gray-600 dark:text-gray-400">There are no items to display at this time.</p>
  </div>
);